import React, { useEffect } from 'react';
import cx from 'classnames'
import './ListeningStatusMicUI.scss'
import { connect } from 'react-redux';
import get from 'lodash.get';
import EnabledMicIcon from '../../images/icons/enabledMic.svg';
import MicSlash from '../../images/icons/iconMicOFF.svg';

function ListeningStatusMicUI({isListening, hideBackground}){

    useEffect(() => {
        console.log('Mic UI isListening:', isListening)
    }, [isListening])

    return <div className="listeningStatusContainer">
        <div className='mic-ui'>
            <div className={cx('mic-background', { 'no-bg': hideBackground, listening: isListening })}>
                <img 
                    src={isListening ? EnabledMicIcon : MicSlash} 
                    alt={isListening ? 'Microphone active' : 'Microphone inactive'}
                    className='mic-icon-svg'
                />
            </div>
        </div>
    </div>
}

const mapStateToProps = state => {
    return {
        isListening: get(state, 'speech.listener.isListening', null),
    }
};
  
export default connect(mapStateToProps)(ListeningStatusMicUI);
  
  